import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';

const ProtectRoute = () => {
    const isLoggedIn = useSelector((state) => state.user.user.is_logged_in);
    // const loginUrl = useSelector(state => state.user.paths.login_url);
    const origin = window.location.origin;
    if(isLoggedIn === false) {
      window.location.replace(`${origin}/login/sso?redirect_url=${origin}/student-dashboard`);
      // window.location.href = loginUrl;
    } else {
      return <Outlet/>;
    }
}

export default ProtectRoute;